import React, { useEffect } from "react";
import { Form, Row, Col, Space, Button } from "antd";
import { InputFields } from "components/common";

const ModalContent = (props) => {
  const { data, closeModal, dataFields, onSubmitForm, loading } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    } else {
      form.resetFields();
    }
  }, [data]);

  const onFinish = (values) => {
    onSubmitForm(values);
  };
  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row gutter={[16, 16]}>
            <InputFields data={dataFields}></InputFields>
          </Row>
          <Row justify="end">
            <Col>
              <Space>
                <Button onClick={closeModal}>Hủy</Button>
                <Button htmlType="submit" type="primary" loading={loading}>
                  Xác nhận
                </Button>
              </Space>{" "}
            </Col>
          </Row>
        </Space>
      </Form>
    </div>
  );
};
export default ModalContent;
